import { Component } from '@angular/core';
/**
 * Displays a simple notification banner or toast-like message consisting of an optional
 * header and a message body.
 *
 * Intended to be used in templates to surface transient informational, success, warning,
 * or error messages to the user. Styling, icons, and dismissal behavior are expected
 * to be provided externally (e.g. via the component's HTML/CSS or a parent controller).
 *
 * Properties:
 * - header: A short, high–level title or label for the notification (e.g. "Success", "Error").
 * - message: The detailed descriptive text to present beneath (or alongside) the header.
 *
 * Example (setting values in a parent component):
 * this.notification.header = 'Profile Updated';
 * this.notification.message = 'Your changes were saved successfully.';
 *
 * Accessibility considerations:
 * - Pair with role="alert" or role="status" on the host element depending on priority.
 * - If the content updates dynamically, ensure assistive technologies are notified
 *   (e.g. aria-live="polite" or "assertive").
 *
 */
@Component({
  selector: 'app-notification',
  imports: [],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent {
  message = '';
  header = '';
}
